import React from 'react';
import ListView from './ListView';
export default function Suites(){
  return <ListView icon="suites" title="Department Suites" subtitle="Skill bundles grouped by department (Marketing, Engineering, etc.)." path="/suites" columns={["id","key","name","included_credits"]} mapRow={r=>r} queryParam="key"/>;
}
